// extracted by mini-css-extract-plugin
module.exports = {"label":"dd31006766--label--K1BzE"};